import axios from 'axios';
export default {
  namespaced: true,
  state: {
    all: [],
    byId: {},
    availableAlternatives: [],
  },
  getters: {
    filter: (state) => (type, subtype, subtypeValue) => state.all.filter((motor) => motor.type === type && motor[subtype] === subtypeValue),
    electric_12_24V: (state) => state.all.filter((m) => m.type === 'electric' && m['current'] === 'dc'),
    electric_220_400V: (state) => state.all.filter((m) => m.type === 'electric' && m['current'] === 'ac'),
    gasoline: (state) => state.all.filter((m) => m.type === 'fuel' && m['fuel_type'] === 'benzine'),
    diesel: (state) => state.all.filter((m) => m.type === 'fuel' && m['fuel_type'] === 'diesel'),
    types: (state, getters) => [
      {
        name: 'Elektrisch 12 / 24V',
        motors: getters.filter('electric', 'current', 'dc'),
      },
      {
        name: 'Elektrisch 220 / 400V',
        motors: getters.filter('electric', 'current', 'ac'),
      },
      {
        name: 'Benzine',
        motors: getters.filter('fuel', 'fuel_type', 'benzine'),
      },
      {
        name: 'Diesel',
        motors: getters.filter('fuel', 'fuel_type', 'diesel'),
      },
    ],
  },
  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'motors')
        .then(({ data }) => {
          commit('setMotors', data);
        });
    },
    getMotorAlternatives({commit, rootGetters}) {
      let motor = rootGetters["build/getMotor"];

      axios.get( process.env.VUE_APP_API_URL + 'alternatives/' + motor.id)
          .then(({ data }) => {
            commit('setAlternatives', data)
          });
    },
  },
  mutations: {
    setMotors(state, motors) {
      if(!motors.length > 0) return
      let byId = {};
      motors.forEach((m) => {
        byId[m.id] = {...m};
      });
      state.byId = byId;
      state.all = motors;
    },
    setAlternatives(state, alternatives) {
      state.availableAlternatives = alternatives;
    }
  },
};
